module.exports = __webpack_public_path__ + "static/img/GG-1.6d25239f.png";